module.exports = __webpack_public_path__ + "48659f45738fa8b0072d91c4acea3275.png";